import { useEffect } from "react";

const updateMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const PageMeta = ({ title, description, keywords, og_tags, canonical_links }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) updateMeta("description", description);
    if (keywords) updateMeta("keywords", keywords);
  }, [title, description, keywords]);

  useEffect(() => {
    if (!og_tags || typeof og_tags !== "object") return;
    const created = [];
    Object.entries(og_tags).forEach(([property, content]) => {
      if (!property || !content) return;
      let el = document.querySelector(`meta[property="${property}"]`);
      console.log(el, { property, content });
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("property", property);
        document.head.appendChild(el);
        created.push(el);
      }
      el.setAttribute("content", content);
    });
    return () => created.forEach((el) => el.parentNode?.removeChild(el));
  }, [og_tags]);

  useEffect(() => {
    if (!Array.isArray(canonical_links) || canonical_links.length === 0) return;
    const created = [];
    canonical_links.forEach(({ tag = "link", attributes = [] }) => {
      const el = document.createElement(tag);
      attributes.forEach(({ key, value }) => el.setAttribute(key, value));
      document.head.appendChild(el);
      created.push(el);
    });
    return () => created.forEach((el) => el.parentNode?.removeChild(el));
  }, [canonical_links]);

  return null;
};

export default PageMeta;
